import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { AuthContext } from '../App';

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/login', form);
      login(res.data.token, res.data.user);
      toast.success('Accesso effettuato!');
      navigate(res.data.user.ruolo === 'admin' ? '/admin' : '/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Errore di accesso');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page fade-in">
      <div className="auth-card">
        <h2>Accedi</h2>
        <p className="subtitle">Accedi al tuo account VerificaIncentivi</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="email@azienda.it" required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="La tua password" required />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 14 }}>
          <Link to="/forgot-password" style={{ color: '#1a56db' }}>Hai dimenticato la password?</Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: 8, fontSize: 14, color: '#6b7280' }}>
          Non hai un account? <Link to="/register">Registrati gratis</Link>
        </p>
      </div>
    </div>
  );
}
